import { useQueryClient } from '@tanstack/react-query'

import { GetConfiguracoesPreco } from '@/features/simulador/brasil/http'
import type { TTipoAmortizacaoEnum } from '@/types/simulacao'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useConfiguracoesDePreco = () => {
  const queryClient = useQueryClient()

  const getConfiguracoesPreco = (
    idExternoProduto: number,
    idExternoBloco: number,
    tipoDeAmortizacao?: TTipoAmortizacaoEnum | null,
  ) => {
    return queryClient.fetchQuery({
      queryKey: produtosKeys.configuracaoDePreco(idExternoProduto, idExternoBloco, tipoDeAmortizacao),
      queryFn: () =>
        new GetConfiguracoesPreco()
          .execute(idExternoProduto, idExternoBloco, tipoDeAmortizacao)
          .then(({ data }) => data),
      staleTime: 1000 * 60 * 1,
    })
  }
  return { getConfiguracoesPreco }
}
